import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DiallerService } from '@app/dialler/services';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { map, scan } from 'rxjs/operators';
import { WorkService } from '../services';

@Component({
  selector: 'app-nailup-modal-content',
  template: `<div class="modal-header">
      <h4 class="modal-title">Hello</h4>
    </div>
    <div class="modal-body">
      <p>Please answer the Call and then click Continue</p>
    </div>
    <div class="modal-footer">
      <ng-container *ngIf="viewModel$ | async as vm">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="this.nailedUp(); activeModal.close('Close click')"
          [disabled]="vm.continueDisabled"
        >
          Continue
        </button>
      </ng-container>

      <button
        type="button"
        class="btn btn-secondary"
        (click)="this.cancel(); activeModal.close('Close click')"
      >
        Cancel
      </button>
    </div>`,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NailupModalContentComponent {
  private disableContinue = new BehaviorSubject<boolean>(true);
  disableContinue$ = this.disableContinue.asObservable();

  viewModel$: Observable<ViewModel>;

  constructor(
    private diallerSvc: DiallerService,
    public activeModal: NgbActiveModal,
    private workSvc: WorkService
  ) {
    this.viewModel$ = this.initViewModel();

    setTimeout(() => this.enableContinue(), 4000);
  }

  private initViewModel() {
    return merge<Partial<ViewModel>>(
      this.disableContinue$.pipe(
        map((continueDisabled) => ({ continueDisabled }))
      )
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }

  cancel() {
    this.workSvc.updateStateToGeneral();
  }

  enableContinue() {
    this.disableContinue.next(false);
  }

  nailedUp() {
    this.diallerSvc.nailedup();
  }
}

interface ViewModel {
  continueDisabled: boolean;
}
